import type {ScribeArtifact} from '@github-ui/scribe-artifacts'

export function shouldFetchIssueArtifacts(resourceId: number): boolean {
  return resourceId > 0
}

export function shouldShowArtifactsSection(artifacts: ScribeArtifact[] | undefined, currentPage = 1): boolean {
  return Boolean(artifacts?.length) || currentPage > 1
}

export function shouldShowCreateArtifactButton(artifacts: ScribeArtifact[] | undefined, currentPage = 1): boolean {
  return currentPage === 1 && Array.isArray(artifacts) && artifacts.length === 0
}
